import styled from 'styled-components';
import { theme } from '@/styles/theme';

interface BadgeProps {
  $variant?: 'primary' | 'secondary' | 'success' | 'warning';
}

export const Badge = styled.span<BadgeProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.xs} ${theme.spacing.md};
  border-radius: ${theme.borderRadius.full};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.semibold};
  font-family: ${theme.fonts.primary};

  ${({ $variant }) => {
    switch ($variant) {
      case 'secondary':
        return `
          background: ${theme.colors.secondary.accent};
          color: ${theme.colors.text.black};
        `;
      case 'success':
        return `
          background: ${theme.colors.primary.extraLight};
          color: ${theme.colors.primary.dark};
        `;
      case 'warning':
        return `
          background: #FFF4E6;
          color: ${theme.colors.status.warning};
        `;
      default:
        return `
          background: ${theme.colors.primary.main};
          color: ${theme.colors.white};
        `;
    }
  }}
`;
